import { fmtDate } from "@/lib/format";
import { isExamSession } from "@/lib/usage";
import { L } from "@/i18n";

const tone = (p) => (p >= 75 ? "text-emerald-400" : p >= 50 ? "text-amber-400" : "text-rose-400");

export const SessionList = ({ sessions }) => (
  <ul className="space-y-2">
    {sessions.map((s) => (
      <li key={s.id} className="flex items-center gap-3 rounded-md bg-[#0f172a] p-3 text-xs" data-testid={`student-session-${s.id}`}>
        <span className={`shrink-0 rounded px-2 py-1 font-mono ${isExamSession(s) ? "bg-sky-500/10 text-sky-300" : "bg-slate-800 text-slate-300"}`}>
          {isExamSession(s) ? L("Exam", "Exame") : L("Quiz", "Quiz")}
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-slate-200 truncate"><b className="font-mono text-amber-400 mr-2">{s.module_title || s.module}</b>{s.mode}</p>
          <p className="mt-0.5 text-slate-500">{fmtDate(s.date, "dd MMM yyyy, HH:mm")}</p>
        </div>
        {s.locked ? (
          <span className="font-mono text-slate-600">{L("locked", "bloqueado")}</span>
        ) : (
          <div className="text-right">
            <p className={`font-mono text-sm font-bold ${tone(s.percentage)}`}>{s.percentage}%</p>
            <p className="font-mono text-slate-500">{s.score}/{s.total}</p>
          </div>
        )}
      </li>
    ))}
  </ul>
);
